import React from 'react';
import { useLoginStep } from './useLoginStep';
import { AuthLoginStepView } from './AuthLoginStepView';

type AuthLoginStepProps = {
    loading?: boolean;
    email: string;
    onLoginSubmit: (password: string) => void;
    onForgotPassword: () => void;
    recoverySuccess?: boolean;
    error?: string | null;
    dismissError?: () => void;
};

export const AuthLoginStep: React.FC<AuthLoginStepProps> = ({
    loading,
    email,
    onLoginSubmit,
    onForgotPassword,
    recoverySuccess,
    error,
    dismissError,
}) => {
    const { register, errors, showPassword, toggleShowPassword, onSubmit } =
        useLoginStep(onLoginSubmit);

    return (
        <AuthLoginStepView
            register={register}
            errors={errors}
            loading={loading}
            email={email}
            showPassword={showPassword}
            recoverySuccess={recoverySuccess}
            error={error}
            dismissError={dismissError}
            onToggleShowPassword={toggleShowPassword}
            onForgotPassword={onForgotPassword}
            onSubmit={onSubmit}
        />
    );
};
